import React from "react";
import { Table } from "react-bootstrap";

export default function ProductTableView({ tableHeader, tableBody = [] }) {
  return (
    <div
      style={{
        // maxHeight: "400px",
        overflowY: "auto",
      }}
    >
      <Table className="product-table mb-0" responsive>
        <thead>
          <tr>
            {tableHeader?.map((item, index) => {
              return (
                <th
                  key={index}
                  className="text-nowrap"
                  style={{ textAlign: item.align }}
                >
                  {item?.name}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {tableBody?.map((item, index) => {
            return (
              <tr key={index}>
                {item?.cell?.map((cell, cellIndex) => {
                  return (
                    <td
                      key={cellIndex}
                      align={cell?.align}
                      style={{
                        verticalAlign: "middle",
                        maxWidth: "400px",
                        wordBreak: "break-word",
                      }}
                    >
                      {cell?.data}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
